export default {

    methods:{
        validateForms:async function(){
            //find every form child of shopping card
            let forms = this.findForms(this.$children)
            let ok = true;
             for(let i = 0; i < forms.length; i++){
                 let form = forms[i]
                 
                 let hasError = await form.hasError();
                //  console.log("resp form hasError:" + resp)
                 if(hasError){
                    setTimeout(() => {
                        const errorElement = document.querySelector('.v-field.error');
                        if (errorElement) {
                            errorElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
                            try{
                            errorElement.querySelector('input').focus();
                            }catch(e){
                                console.log("error focus input")
                            }
                        }
                    }, 100);
                    //  console.log("form has error")
                     ok = false
                 }
             }
            return ok
        },
 
        findForms:function(VueNodes){
             let fields = []
               
             if(_.isArray(VueNodes)){
                 for (let i = 0; i < VueNodes.length; i++) {
                     const vm = VueNodes[i];
                     if(  _.get(vm,'$options.name') ==='vue-form'){
                         fields.push(vm);
                     }
                     if(vm.$children){
                        fields = [...fields,...this.findForms(vm.$children)]
                     }
                 }
             }
             return fields;
         },
        }
}